export default __webpack_public_path__ + "static/media/close-icon-white.b51d767f.svg";